


















































import Toolbar from '@/components/Toolbar.vue';
import { Component, Vue } from 'vue-property-decorator';
import { AnswerUpdater } from './AnswerUpdater';
import { Answer, Question } from './dataContracts';
import { DeclinedUpdater } from './DeclinedUpdater';
import { NoteUpdater } from './NoteUpdater';
import SurveyQuestion from './SurveyQuestion.vue';
import { ViewQuestion } from './ViewQuestion';

// interfaces for type safety with tests
interface UpdaterObj {
  updateAnswer: AnswerUpdater;
  updateDeclined: DeclinedUpdater;
  updateNote: NoteUpdater;
}

@Component({
  components: {
    SurveyQuestion,
    Toolbar,
  },
})
export default class Survey extends Vue implements UpdaterObj {
  public updateAnswer(newAnswer: Answer, oldQuestion: ViewQuestion) {
    if (
      oldQuestion.type === 'options-all' &&
      newAnswer &&
      typeof newAnswer === 'string'
    ) {
      newAnswer = newAnswer.split(',');
    }
    this.$store.dispatch('updateAnswer', {
      answer: newAnswer,
      surveyId: this.$store.state.survey.id,
      questionId: oldQuestion.id,
    });
  }

  public updateDeclined(newDecline: boolean, oldQuestion: ViewQuestion) {
    this.$store.dispatch('updateDeclinedQuestion', {
      declined: newDecline,
      surveyId: this.$store.state.survey.id,
      questionId: oldQuestion.id,
    });
  }

  public updateNote(newNote: string, oldQuestion: ViewQuestion) {
    this.$store.dispatch('updateNote', {
      note: newNote,
      surveyId: this.$store.state.survey.id,
      questionId: oldQuestion.id,
    });
  }

  private async created() {
    await this.$store.dispatch('bindSurvey', {
      surveyId: this.$route.params.id,
    });
  }

  private destroyed() {
    this.$store.dispatch('unbindSurvey');
  }

  get categories() {
    return this.$store.getters.questionsInCategories;
  }

  private anchorize(aString: string) {
    return `#${aString}`;
  }
}
